import { Link } from "react-router-dom";
import { useAccount } from "wagmi";
import { useMarketCount } from "@/hooks/useMarkets";
import MarketList from "@/components/markets/MarketList";
import StatCard from "@/components/ui/StatCard";

export default function HomePage() {
  const { isConnected } = useAccount();
  const { data: marketCount } = useMarketCount();

  return (
    <div>
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-primary-600 to-primary-800 rounded-xl p-8 mb-8 text-white">
        <div className="max-w-2xl">
          <h1 className="text-3xl md:text-4xl font-bold mb-3 tracking-tight">
            Trade the outcomes that move markets
          </h1>
          <p className="text-primary-100 text-lg mb-6">
            On-chain prediction markets for DeFi &amp; TradFi. Take a position on earnings,
            protocol metrics, and regulatory calls priced by the crowd.
          </p>
          <div className="flex flex-wrap gap-4">
            {isConnected ? (
              <Link to="/create" className="btn bg-white text-primary-700 hover:bg-primary-50">
                Create Market
              </Link>
            ) : (
              <div className="text-primary-200 text-sm">
                Connect a wallet to take a position or launch your own market.
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
        <StatCard label="Total Markets" value={marketCount?.toString() || "0"} />
        <StatCard label="Settlement" value="USDT" hint="ERC-20, 6 decimals" />
        <StatCard label="Network" value="Ethereum" hint="L1" />
        <StatCard label="Platform Fee" value="2%" hint="rake on resolved pools" />
      </div>

      {/* Markets Section */}
      <div className="mb-4">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Markets</h2>
        <p className="text-gray-600">
          Browse active prediction markets or view resolved outcomes
        </p>
      </div>

      <MarketList />
    </div>
  );
}
